import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { BusService } from '../shared/services/bus.service';
import { LibAuthService } from 'ngx-tin-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthEmployeGuard implements CanActivate {
  constructor(
    private auth: LibAuthService,
    private authService: AuthService,
    private serviceBus: BusService
  ) {}
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const _route = route as any;
    if (route.data['module'] && route.data['module'] !== '') {
      this.serviceBus.module =  route.data['module'];
    }
    if ((route as any)._routerState) {
      this.serviceBus.initialRoute =  _route._routerState?.url?.split('?')[0];
      if (_route.queryParams && Object.keys(_route.queryParams).length > 0) {
        this.serviceBus.initialQueryParams = _route.queryParams;
      }
    }
    if (await this.auth.isUserLoggedIn()) {
      if (await this.authService.hasAccessModuleEmploye()) {
        await this.authService.loadPermissions();
        this.authService.authorizedUser();
        return true;
      } else {
        this.authService.unauthorizedUser();
        return false;
      }
    } else {
      this.auth.federatedSignIn();
      return false;
    }
  }

}
